import { jsx as _jsx } from "react/jsx-runtime";
// NOT block-registry.gen: importing it here would close the block ↔ registry ↔ renderer cycle that
// Vite's dev SSR refuses. See renderer/default-registry.ts.
import { getDefaultBlockRegistry } from './default-registry.js';
import { BlockErrorBoundary } from './BlockErrorBoundary.js';
import { FallbackBlock } from './FallbackBlock.js';
/**
 * Render ONE block through the registry. A HIDDEN (disabled) block is REMOVED from the canvas in BOTH the
 * builder ('edit') and the live store — clicking the eye makes it disappear, exactly like Shopify. The
 * left rail still lists a hidden block (with an eye-off) so it can be shown again. Unknown type →
 * FallbackBlock.
 */
export function BlockRenderer({ block, context, registry }) {
    if (block.disabled)
        return null;
    const def = (registry ?? getDefaultBlockRegistry())[block.type];
    const child = !def ? (_jsx(FallbackBlock, { type: block.type, mode: context.renderMode })) : (_jsx(BlockErrorBoundary, { mode: context.renderMode, children: _jsx(def.Component, { block: block, context: context }) }));
    // Builder "select mode" hook: in EDIT mode wrap the child in a LAYOUT-INVISIBLE span carrying the block id,
    // so a canvas click resolves the block via `closest('[data-aqx-block-id]')`. `display:contents` emits no box
    // (the child's own root stays the flex/grid item), and the span is still found by `closest()` regardless of
    // display. In LIVE mode the child renders bare → storefront DOM byte-identical (no SSR/CLS impact).
    if (context.renderMode === 'edit') {
        return (_jsx("span", { "data-aqx-block-id": block.id, style: { display: 'contents' }, children: child }));
    }
    return child;
}
/**
 * Render a block LIST in array order — the recursive `content_for 'blocks'`. Each child renders
 * directly; the caller decides any wrapper element. Pass `registry` to thread an extended registry
 * down a nested tree.
 */
export function renderBlocks(blocks, context, registry) {
    return (blocks ?? []).map((b) => (_jsx(BlockRenderer, { block: b, context: context, registry: registry }, b.id)));
}
//# sourceMappingURL=BlockRenderer.js.map